import React from "react";
import {
  CheckOutlined,
  DoubleRightOutlined,
  EyeOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./home.css";
import {
  Avatar,
  Col,
  Flex,
  Row,
  Card,
  Button,
  Rate,
  Tag,
  Carousel,
  Image,
  Space,
  Typography,
} from "antd";

import { ReactComponent as Visa } from "../assets/images/visa.svg";
import { ReactComponent as Hotel } from "../assets/images/hotel.svg";
import { ReactComponent as BreakFast } from "../assets/images/breakFast.svg";
import { ReactComponent as Transport } from "../assets/images/transport.svg";
import { ReactComponent as Activities } from "../assets/images/activities.svg";
import { Input } from "antd";
import activitiesImg from "../assets/images/activities.jpg";
import crazyDealImg from "../assets/images/crazyDeals.jpg";
import hotelImg from "../assets/images/hotel.jpg";
import holidayImg from "../assets/images/holiday.jpg";
import visaImg from "../assets/images/visa.jpg";
import cruiseImg from "../assets/images/cruise.jpg";
import spatialImg from "../assets/images/spe-1.jpg";
import spatialTowImg from "../assets/images/spe-2.jpg";
import spatialThreeImg from "../assets/images/spe-3.jpg";
import exploreCountryImg from "../assets/images/ex-country-1.jpg";
import exploreCountryTwoImg from "../assets/images/ex-country-2.jpg";
import exploreCountryThreeImg from "../assets/images/ex-country-3.jpg";
import efficientBg from "../assets/images/efficient-1.webp";

import sliderImg from "../assets/images/slider-1.jpg";
import { ReactComponent as CheckOutlinedCustom } from "../assets/images/checkbox-icon.svg";
import { ReactComponent as Accommodation } from "../assets/images/accommodation.svg";
import { ReactComponent as AllMeals } from "../assets/images/all-meals.svg";
import { ReactComponent as OnTourTransport } from "../assets/images/On-tour transport.svg";
import { ReactComponent as BestValueItinerary } from "../assets/images/best-value-itinerary.svg";
import { ReactComponent as TourManagers } from "../assets/images/tour-managers.svg";
import { useCity } from "../context/CityContext";

import {
  GiftOutlined,
  DollarOutlined,
  HomeOutlined,
  CompassOutlined,
  FileDoneOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import Title from "antd/es/typography/Title";
import MegaMenu from "../components/MegaMenu";

import SearchDropdown from "../components/SearchDropdown";
import { useNavigate } from "react-router-dom";
import SpatialOffers from "../components/SpatialOffers";
import ExploreTopThingsToDoDubai from "../components/ExploreTopThingsToDoDubai";
import ExploreTopThingsToDoCountry from "../components/ExploreTopThingsToDoCountry";
import SpatialToursSection from "../components/SpatialToursSection";
import ExploreTopMustDoThings from "../components/ExploreTopMustDoThings";
const { Text, Paragraph } = Typography;

const categories = [
  {
    title: "Activities",
    desc: "your wanderlust awaits!",
    icon: <GiftOutlined />,
    img: activitiesImg,
    route: "/activity",
  },
  {
    title: "Crazy Deals",
    desc: "Deal on Hotel and Flights",
    icon: <DollarOutlined />,
    img: crazyDealImg,
    route: "/crazy-deals",
  },
  {
    title: "Hotel",
    desc: "your wanderlust awaits!",
    icon: <HomeOutlined />,
    img: hotelImg,
    route: "/hotel",
  },
  {
    title: "Holiday",
    desc: "your wanderlust awaits!",
    icon: <CompassOutlined />,
    img: holidayImg,
    route: "/holidays",
  },
  {
    title: "Visa",
    desc: "your wanderlust awaits!",
    icon: <FileDoneOutlined />,
    img: visaImg,
    route: "/visa-search",
  },
  {
    title: "Cruise",
    desc: "your wanderlust awaits!",
    icon: <RocketOutlined />,
    img: cruiseImg,
    route: "/cruise-search",
  },
];

const offers = [
  {
    img: spatialImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialTowImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
  {
    img: spatialThreeImg,
    title: "Up to 35% OFF (upto Rs.6,000)",
    desc: "On Domestic Hotels",
    note: "*Offers is Valid Only On Confirmed Hotel Bookings",
  },
];

const tours = [
  {
    id: 1,
    image: exploreCountryImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Standard",
    tagColor: "blue",
    badgeColor: "#10239E",
  },
  {
    id: 2,
    image: exploreCountryTwoImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Premium",
    tagColor: "gold",
    badgeColor: "#D72638",
  },
  {
    id: 3,
    image: exploreCountryThreeImg,
    price: "INR 1,43,200",
    oldPrice: "INR 2,65,185",
    savings: "SAVE INR 1,21,985",
    type: "Value",
    tagColor: "green",
    badgeColor: "#D72638",
  },
];

const highlights = [
  "Dubai and Bali Honeymoon Bliss | City Romance to Tropical Retreat",
  "Best Of Dubai | FREE Universal Studio Tickets Dubai & Malaysia Trip | FREE Night Safari Experience",
];

const toursForYou = [
  {
    title: "Best Selling UAE Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "International Tourist Visas",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Trending Cruise Destinations",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
  {
    title: "Best Selling Dubai Tours",
    text: "Abu Dhabi City Tour With Ferrari World | Abu Dhabi City Tour | Burj Khalifa At The Top Tickets | Ski Dubai Tickets | Exotic Sunrise With Balloon Flights Dubai | Musandam Dibba Tour | Ferrari World Tickets | Kidzania Abu Dhabi | Louvre Abu Dhabi | Desert Safari Abu Dhabi | Dhow Cruise Abu Dhabi | Jebel Jais Zipline | Ras Al Khaimah City Tour | Deep Dive Dubai | Evening Desert Safari Dubai | Morning Desert Safari Dubai | Museum Of The Future Tickets | Ain Dubai Tickets",
  },
];

const inclusiveTours = [
  {
    icon: <Accommodation />,
    title: "Accommodation",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <AllMeals />,
    title: "All meals",
    description: "Eat to your heart's content Breakfast. Lunch. Dinner.",
  },
  {
    icon: <OnTourTransport />,
    title: "On-tour transport",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <BestValueItinerary />,
    title: "Best value itinerary",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
  {
    icon: <TourManagers />,
    title: "Tour managers",
    description:
      "Comfortable & convenient hotels cherry picked by our hotel management team",
  },
];

const { Search } = Input;

const Home = () => {
  const navigate = useNavigate(); // ✅ hook used inside the component
  const { selectedCity } = useCity();
  return (
    <>
      <section
        id="banner-section"
        className="relative bg-cover bg-center text-center text-white items-center justify-center min-h-[500px]"
      >
        <Image
          src={efficientBg}
          alt="Slide 1"
          className="w-full !h-full object-cover min-h-[670px] sm:min-h-[400px] max-h-[464px]"
          preview={false}
          style={{ height: "100%" }}
        />

        <div className=" absolute z-10 top-10 left-0 right-0">
          <div className="container">
            <h1 className="text-3xl lg:text-6xl font-bold pt-12 px-4 ">
              Planning for Holiday in <span className=" animate-pulse">{selectedCity?.name} ?</span>
            </h1>
            <h1 className="text-xl lg:text-3xl my-4 px-4">
              We have some special Tours for you
            </h1>
            <Row
              gutter={[0, 16]}
              justify="center"
              align="middle"
              className="my-6 w-full lg:w-1/3 mx-auto"
            >
              <Col xs={12} sm={6} md={6} lg={6} xl={6} className="text-center">
                <Avatar
                  size={50}
                  icon={<Activities size={20} />}
                  className="bg-white mb-1"
                />
                <div>Activities</div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6} xl={6} className="text-center">
                <Avatar size={50} icon={<Hotel />} className="bg-white mb-1" />
                <div>Holidays</div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6} xl={6} className="text-center">
                <Avatar
                  size={50}
                  icon={<Transport />}
                  className="bg-white mb-1"
                />
                <div>TRANSPORT</div>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6} xl={6} className="text-center">
                <Avatar size={50} icon={<Visa />} className="bg-white mb-1" />
                <div>Visa</div>
              </Col>
            </Row>
            <h2 className="text-lg lg:text-2xl my-4 px-4">
              Please help us to find great tour for you!
            </h2>

            {/* <Row
              gutter={[0, 16]}
              justify="center"
              align="middle"
              className="my-6 mx-auto"
            >
              <Col xs={24} className="text-center px-8">
                <SearchDropdown size="h-16" />
              </Col>
            </Row> */}
          </div>
        </div>
      </section>

      <section className="mt-8 lg:mt-[-75px] text-center text-white mb-2">
        <div className="container mx-auto px-4 sm:px-4 md:px-4 lg:px-0">
          <Row gutter={[16, 16]} justify="center" className="">
            {categories.map((item, i) => (
              <Col xs={24} sm={12} md={8} lg={6} xl={4} key={i}>
                <Card
                  hoverable
                  styles={{ body: { padding: 0 } }}
                  className="rounded-xl overflow-hidden text-white relative border-0"
                  onClick={() => navigate(item.route)} // ✅ navigate on click
                >
                  <div
                    className="h-170 bg-cover bg-center relative"
                    style={{ backgroundImage: `url(${item.img})` }}
                  >
                    {/* 🔹 Overlay layer */}
                    <div className="absolute inset-0 bg-gradient-to-b from-black/0 to-black/70" />

                    {/* 🔹 Content above overlay */}
                    <div className="absolute bottom-0 left-0 right-0 p-4 text-left">
                      <div className="flex items-center gap-1 text-base font-normal">
                        {item.icon}
                        {item.title}
                      </div>
                      <small className="text-gray-200 font-normal">
                        {item.desc}
                      </small>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </section>





      {/* Banner Slider  */}
      {/* <section className="hidden sm:block p-6">
        <div className="container">
          <Carousel
            autoplay
            dots
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <div>
              <div className="ant-image-100">
                <Image
                  src={sliderImg}
                  alt="Slide 1"
                  className="w-full !h-full object-cover"
                  preview={false}
                />
              </div>

              <Flex
                className="absolute inset-0 text-white px-12 py-8"
                align="start"
                justify="space-between"
              >
                <Flex
                  flex={1}
                  justify="space-between"
                  className="h-full"
                  vertical
                >
                  <Flex justify="start" vertical align="start">
                    <Title
                      level={1}
                      className="!text-white rounded !mb-0 text-center"
                    >
                      Dubai
                    </Title>

                    <Title
                      level={2}
                      className="!text-white  rounded text-center large !mt-0 !mb-0"
                    >
                      TOUR PACKAGES
                    </Title>
                  </Flex>
                  <Flex gap={30}>
                    <Flex align="center" vertical gap={10}>
                      <Avatar
                        size={75}
                        icon={<Hotel className="w-12 h-12" />}
                        className="bg-white mb-1"
                      />
                      <div>HOTEL</div>
                    </Flex>

                    <Flex align="center" vertical gap={10}>
                      <Avatar
                        size={75}
                        icon={<Transport className="w-12 h-12" />}
                        className="bg-white mb-1"
                      />
                      <div>TRANSPORT</div>
                    </Flex>

                    <Flex align="center" vertical gap={10}>
                      <Avatar
                        size={75}
                        icon={<BreakFast className="w-12 h-12" />}
                        className="bg-white mb-1"
                      />
                      <div>BREAKFAST</div>
                    </Flex>
                  </Flex>

                  <div className="text-white">
                    <Space direction="vertical" size="middle">
                      {highlights.map((item, index) => (
                        <div key={index} className="flex items-center gap-8">
                          <div className="min-w-[2rem] min-h-[2rem] flex items-center justify-center rounded-full">
                            <CheckOutlinedCustom className="text-white text-4xl" />
                          </div>
                          <Text className="text-white font-medium leading-snug text-xl">
                            {item}
                          </Text>
                        </div>
                      ))}
                    </Space>
                    <Text></Text>
                  </div>
                </Flex>

                <Flex
                  flex={1}
                  justify="center"
                  align="center"
                  className="h-full"
                  vertical
                >
                  
                  <div className="relative w-[90%] max-w-3xl border border-white rounded-xl text-white text-center px-6 py-6">
                  
                    <div className="absolute -top-[15px] left-0 w-full flex items-center justify-center">
                      <div className="flex items-center justify-center w-full px-6 leading-none">
                        <span className="mx-4 text-lg font-semibold bg-[#00000090] px-2 py-[1px] rounded">
                          STARTING PRISE
                        </span>
                      </div>
                    </div>
                  
                    <div className="absolute -top-5 -right-8 transform rotate-45 bg-blue-600 text-white text-lg font-bold px-3 py-[2px] shadow-md">
                      <Title
                        level={4}
                        className="!text-white !mb-0 !font-medium"
                      >
                        4N/5D
                      </Title>
                    </div>

                    
                    <h1 className="large font-black leading-none">
                      INR 35,999
                    </h1>
                    <p className="uppercase text-xl font-semibold tracking-wide">
                      PER PERSON (BASED ON 2 PAX)
                    </p>
                  </div>

                  <Flex
                    vertical
                    className="w-[60%] mx-auto"
                    justify="center"
                    align="center"
                  >
                    
                    <div className="w-full h-[4px] bg-white rounded-full my-10 mx-auto"></div>

                    
                    <Button
                      type="danger"
                      size="large"
                      className="font-semibold text-3xl w-full m-auto py-8 rounded-tl-[12px] rounded-bl-none rounded-tr-none rounded-br-[12px] bg-white  border-none rounded-md px-4 py-1 text-[12273D] w-fit"
                    >
                      Book Now!
                    </Button>
                  </Flex>
                </Flex>
              </Flex>
            </div>
          </Carousel>
        </div>
      </section> */}
      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <ExploreTopThingsToDoCountry />
        </div>
      </section>

      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <ExploreTopMustDoThings />
        </div>
      </section>
      <section className="py-4 px-4 lg:px-0">
        <div className="container">
          <SpatialToursSection />
        </div>
      </section>
      {/* <section className="p-6">
        <div className="container">
          
          <Flex justify="center" align="start" vertical className="pb-6">
            <h2 className="text-3xl font-normal text-primary">
              We have some spatial{" "}
              <span className="text-danger">Tours for You!</span>
            </h2>
            <p className="font-normal mt-1">
              Culture, nature, thrills, and record-breaking experiences
            </p>
          </Flex>

          {toursForYou.map((tours, index) => (
            <div key={index} className="mb-8">
              <Title
                level={5}
                className="text-[15px] font-semibold  mb-2 leading-normal"
              >
                {tours.title}
              </Title>
              <Paragraph className="text-xs font-medium  leading-relaxed mb-0">
                {tours.text}
              </Paragraph>
            </div>
          ))}
        </div>
      </section> */}

      <section className="p-6 bg-white text-center">
        <div className="container relative">
          {/* Title with gradient */}
          <Flex
            justify="center"
            align="center"
            vertical
            className="mb-10 relative"
          >
            <h2 className="text-3xl font-normal text-primary">
              The All <span className="text-danger">Inclusive Tours</span>
            </h2>
            <div className=" mt-2 w-[300px] h-[4px] heading-border"></div>
          </Flex>

          <div className="">
            <svg
              className="absolute z-0  w-[86%] left-0 right-0 m-auto h-32 pointer-events-none hidden lg:block"
              viewBox="0 0 1000 100"
              preserveAspectRatio="none"
            >
              <path
                d="M0,50 C200,-50 800,150 1000,50"
                stroke="#000"
                strokeWidth="1"
                fill="transparent"
              />
            </svg>

            {/* Main timeline section */}
            <Row gutter={[16, 16]} className="relative top-[0px] mt-12">
              {inclusiveTours.map((item, index) => {
                // Define margin top classes
                const marginTopClasses = [
                  "lg:mt-[0px]",
                  "lg:mt-[-20px]",
                  "lg:mt-[15px]",
                  "lg:mt-12",
                  "lg:mt-[20px]",
                ];

                // Fallback to last one if index is larger
                const mtClass = marginTopClasses[index] || "mt-20";

                // If last item → lg={4}, else lg={5}
                const isLast = index === inclusiveTours.length - 1;
                const colProps = { xs: 24, md: 8, lg: isLast ? 4 : 5 };

                return (
                  <Col
                    key={index}
                    {...colProps}
                    align="center"
                    className={mtClass}
                  >
                    <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center shadow-md mb-4">
                      {item.icon}
                    </div>
                    {/* Title */}
                    <Title level={5} className="text-[14] mb-1 !font-medium">
                      {item.title}
                    </Title>
                    {/* Description */}
                    <Text
                      type="secondary"
                      className="text-xs font-medium leading-snug"
                    >
                      {item.description}
                    </Text>
                  </Col>
                );
              })}
            </Row>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
